var map = {
	"./Abu-Dhabi-Grand-Prix.png": 4897,
	"./Australian-Grand-Prix.png": 1266,
	"./Austrian-Grand-Prix.png": 5187,
	"./Azerbaijan-Grand-Prix.png": 4363,
	"./Bahrain-Grand-Prix.png": 3312,
	"./Belgian-Grand-Prix.png": 8807,
	"./Brazilian-Grand-Prix.png": 1180,
	"./British-Grand-Prix.png": 8615,
	"./Canadian-Grand-Prix.png": 1234,
	"./China-Grand-Prix.png": 8314,
	"./Dutch-Grand-Prix.png": 8626,
	"./Eifel-Grand-Prix.png": 1775,
	"./Emilia-Romagna-Grand-Prix.png": 9556,
	"./French-Grand-Prix.png": 7474,
	"./German-Grand-Prix.png": 6941,
	"./Hungarian-Grand-Prix.png": 445,
	"./Italian-Grand-Prix.png": 1552,
	"./Japanese-Grand-Prix.png": 1068,
	"./Mexico-City-Grand-Prix.png": 6232,
	"./Miami-Grand-Prix.png": 2701,
	"./Monaco-Grand-Prix.png": 4592,
	"./Portugal-Grand-Prix.png": 9913,
	"./Qatar-Grand-Prix.png": 4141,
	"./Russia-Grand-Prix.png": 5082,
	"./Saudi-Arabian-Grand-Prix.png": 2971,
	"./Singapore-Grand-Prix.png": 2570,
	"./Spanish-Grand-Prix.png": 7451,
	"./Toscana-Grand-Prix.png": 5985,
	"./Turkey-Grand-Prix.png": 2401,
	"./United-States-Grand-Prix.png": 9702,
	"./Vietnam-Grand-Prix.png": 6308
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7662;